import { Component, Inject, signal } from '@angular/core'
import { form, required, validate } from '@angular/forms/signals'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface LaskutusprofiiliLisaaDialogData {
  lahdeprofiilinNimi: string
}

interface LaskutusprofiiliLisaaLomake {
  nimi: string
}

@Component({
  templateUrl: './laskutusprofiili-lisaa.dialog.html',
  styleUrls: ['./laskutusprofiili-lisaa.dialog.css'],
  standalone: false,
})
export class LaskutusprofiiliLisaaDialog {
  readonly lomake = form(signal<LaskutusprofiiliLisaaLomake>({ nimi: '' }), polku => {
    required(polku.nimi)
    validate(polku.nimi, ({ value }) => {
      const nimiOnLiianLyhyt = (value() ?? '').trim().length < 2
      return nimiOnLiianLyhyt ? { kind: 'minlength' } : null
    })
  })

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: LaskutusprofiiliLisaaDialogData,
    private _dialogRef: MatDialogRef<LaskutusprofiiliLisaaDialog, string>,
  ) {}

  luoUusiProfiili() {
    if (this.lomake().invalid()) {
      this.lomake().markAsTouched()
      return
    }
    this._dialogRef.close(this.lomake.nimi().value().trim())
  }
}
